module.exports = __webpack_public_path__ + "static/media/dharmachakra.91a711cd.svg";